import styled, { css } from "styled-components";

export const Container = styled.div`
  width: 100%;
  position: relative;
  box-sizing: border-box;
  padding-bottom: 24px;
`;

export const OverlayLoader = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(4px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: 12px;

  p {
    margin-top: 16px;
    font-size: 16px;
    font-weight: 600;
    color: var(--fixit);
  }
`;

export const Spinner = styled.div`
  width: 48px;
  height: 48px;
  border: 4px solid rgba(152, 53, 209, 0.2);
  border-left-color: var(--fixit);
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    to { transform: rotate(360deg); }
  }
`;

export const LeftPanel = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const StepTitle = styled.h2`
  font-size: 24px;
  font-weight: 700;
  color: var(--black);
  margin-bottom: 24px;
`;

export const HeaderAction = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: transparent;
  border: 1px solid var(--fixit);
  color: var(--fixit);
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  padding: 12px 24px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(152, 53, 209, 0.05);
  }
`;

export const StepDescription = styled.p`
  color: var(--gray);
  margin-bottom: 16px;
  text-align: center;
`;

export const SectionContainer = styled.div`
  margin-bottom: 24px;
`;

export const CardDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  border: 1px solid var(--light-gray);
  padding: 24px;
  border-radius: 12px;
  background-color: var(--white);
`;

export const PixContainer = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  border: 1px solid var(--light-gray);
  padding: 24px;
  border-radius: 12px;
  align-items: center;
  text-align: center;

  h3 {
    font-size: 18px;
    color: var(--black);
  }

  p {
    color: var(--gray);
    font-size: 14px;
  }
`;

export const PixBox = styled.div`
  width: 100%;
  max-width: 400px;
  margin: 16px auto 0 auto;
  background-color: rgba(152, 53, 209, 0.05);
  border-radius: 16px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  border: 2px solid var(--fixit);
`;

export const QrCodeImage = styled.img`
  width: 200px;
  height: 200px;
  border-radius: 8px;
  border: 1px solid var(--light-gray);
`;

export const CopyPasteContainer = styled.div`
  width: 100%;
  background-color: var(--white);
  border: 1px dashed var(--gray);
  border-radius: 8px;
  padding: 32px 16px 16px 16px;
  position: relative;
  word-break: break-all;
  font-size: 14px;
  color: var(--dark-gray);
  text-align: left;
`;

export const CopyButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  background-color: transparent;
  color: var(--fixit);
  border: none;
  border-radius: 4px;
  padding: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: bold;
  font-size: 12px;
  transition: all 0.2s;

  &:hover {
    color: var(--black);
  }
`;

export const PaymentArea = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SecurityBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 16px;
  font-size: 13px;
  color: var(--gray);
  width: 100%;
  text-align: center;
`;

export const BillingBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  background-color: var(--white);
  border-radius: 12px;
  border: 1px solid var(--light-gray);
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.02);
`;

export const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const RadioOption = styled.div<{ active: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid ${({ active }) => (active ? "var(--fixit)" : "var(--light-gray)")};
  background-color: ${({ active }) => (active ? "rgba(152, 53, 209, 0.05)" : "var(--white)")};
  cursor: pointer;
  font-weight: 600;
  color: var(--dark-gray);
  transition: all 0.2s ease;

  .radio-circle {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 2px solid ${({ active }) => (active ? "var(--fixit)" : "var(--gray)")};
    display: flex;
    align-items: center;
    justify-content: center;

    &::after {
      content: '';
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: var(--fixit);
      display: ${({ active }) => (active ? "block" : "none")};
    }
  }

  svg {
    font-size: 20px;
    color: ${({ active }) => (active ? "var(--fixit)" : "var(--gray)")};
  }

  &:hover {
    border-color: var(--fixit);
  }
`;

export const PaymentMethodGrid = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;

  @media (max-width: 768px) {
    gap: 8px;
  }
`;

export const PaymentCard = styled.div<{ selected: boolean }>`
  flex: 1;
  border: 2px solid ${({ selected }) => (selected ? "var(--fixit)" : "var(--light-gray)")};
  border-radius: 12px;
  padding: 16px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 8px;
  background-color: ${({ selected }) => (selected ? "rgba(152, 53, 209, 0.08)" : "var(--white)")};
  transition: all 0.2s ease;

  svg {
    font-size: 28px;
    color: ${({ selected }) => (selected ? "var(--fixit)" : "var(--gray)")};
  }

  @media (max-width: 768px) {
    padding: 12px 8px;
    border-radius: 8px;
    svg { font-size: 24px; }
  }
`;

export const PlanTitle = styled.h3`
  font-size: 16px;
  font-weight: 700;
  color: var(--black);
  margin: 0;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const PlanPrice = styled.div` display: none; `;
export const PlanDescription = styled.p` display: none; `;

export const Row = styled.div`
  display: flex;
  gap: 16px;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

export const FlexInput = styled.div<{ flex?: number }>`
  flex: ${({ flex }) => flex || 1};
  display: flex;
  flex-direction: column;
`;

export const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 8px;
  padding: 4px;
  width: fit-content;
`;

export const SwitchButton = styled.button<{ active: boolean }>`
  padding: 8px 24px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: ${({ active }) => (active ? "var(--white)" : "transparent")};
  color: ${({ active }) => (active ? "var(--fixit)" : "var(--gray)")};
  box-shadow: ${({ active }) => (active ? "0px 2px 8px rgba(0,0,0,0.05)" : "none")};
`;

export const CheckoutCheckbox = styled.input`
  width: 20px;
  height: 20px;
  cursor: pointer;
  accent-color: var(--fixit);
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  color: var(--dark-gray);
  cursor: pointer;
  margin-top: 8px;
  font-weight: 500;
`;

/* === ESTILO ANTIGO (MANTIDO AQUI CASO VOCÊ QUEIRA REVERTER) ===
export const SectionTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: var(--black);
  margin-bottom: 8px;
`;
============================================================= */

// NOVO ESTILO (Testando padrão do StepDelivery/PersonalData)
export const SectionTitle = styled.h2`
  font-size: 20px;
  font-weight: 700;
  color: var(--fixit);
  margin-bottom: 8px;
  margin-top: 16px;
  border-bottom: 1px solid var(--light-gray);
  padding-bottom: 8px;
`;

export const SelectBox = styled.select`
  width: 100%;
  padding: 14px 16px;
  border: 1px solid var(--gray);
  border-radius: 8px;
  font-size: 16px;
  color: var(--dark-gray);
  background-color: var(--white);
  outline: none;
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23666' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px;

  &:focus {
    border-color: var(--fixit);
    box-shadow: 0 0 0 3px rgba(152, 53, 209, 0.1);
  }
`;

export const CouponContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
  border-bottom: 1px dashed var(--light-gray);
  padding-bottom: 16px;

  .coupon-input-row {
    display: flex;
    gap: 8px;
    align-items: flex-end;
  }
  
  .coupon-applied {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #e8f5e9;
    color: #2e7d32;
    padding: 12px 16px;
    border-radius: 8px;
    border: 1px solid #c8e6c9;
    font-size: 14px;
    font-weight: 600;

    button {
      background: none;
      border: none;
      color: #2e7d32;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 4px;
      border-radius: 50%;
      
      &:hover {
        background: rgba(46, 125, 50, 0.1);
      }
    }
  }
`;

export const TotalValueBar = styled.div`
  background: var(--white);
  border: 1px solid var(--light-gray);
  padding: 32px;
  border-radius: 12px;
  margin-top: 16px;
  box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.05);

  .total-text {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 18px;
    font-weight: 600;
    color: var(--dark-gray);
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 1px solid var(--light-gray);

    .price {
      font-size: 28px;
      font-weight: 800;
      color: var(--black);
    }
  }
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid var(--light-gray);
`;

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid var(--light-gray);
  margin: 16px 0 8px 0;
  width: 100%;
`;

export const BillingAddressContainer = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 12px;
  border: 1px solid var(--light-gray);
`;